export const sessionExpired = () => {
    if (typeof window !== "undefined" && window.location.pathname === "/login/") {
        return;
    }

    function updateTokenExpiryTime() {
        const tokenInput = document.getElementById("request-session");
        if (!tokenInput || !tokenInput.value) {
            return;
        }
        const tokenExpiryTime = parseInt(tokenInput.value) - 300;
        const currentTime = Math.floor(new Date().getTime() / 1000);
        const timeDiff = tokenExpiryTime - currentTime;
        const modal = document.getElementById("session-expired");
        if (tokenExpiryTime > 0) {
            if (timeDiff > 0) {
                modal.classList.add("hidden");
            } else {
                modal.classList.remove("hidden");
            }
        }
    }
    updateTokenExpiryTime();
    setInterval(updateTokenExpiryTime, 1000);
}

